import React, { useState } from 'react';
import { X, Calendar, MapPin, Target, Zap, Clock, Activity } from 'lucide-react';

const EventModal = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    date: '',
    location: '',
    distance: '',
    elevation: '',
    targetTime: '',
    type: 'running',
    priority: 'A'
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name || !formData.date || !formData.distance) {
      alert("Por favor rellena al menos el Nombre, Fecha y Distancia del evento.");
      return;
    }
    onSave({ ...formData, id: Date.now() });
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'rgba(0,0,0,0.7)', backdropFilter: 'blur(8px)', padding: '1rem'
    }}>
      <div className="glass-panel" style={{
        width: '100%', maxWidth: '500px', padding: '2rem', borderRadius: '24px', position: 'relative',
        boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)', border: '1px solid var(--glass-border)'
      }}>
        
        <button onClick={onClose} style={{
          position: 'absolute', top: '1.5rem', right: '1.5rem', background: 'rgba(255,255,255,0.05)',
          border: 'none', color: 'var(--text-secondary)', cursor: 'pointer', borderRadius: '50%', padding: '0.5rem',
          display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s'
        }} onMouseOver={e => { e.currentTarget.style.color = 'white'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }} onMouseOut={e => { e.currentTarget.style.color = 'var(--text-secondary)'; e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}>
          <X size={20} />
        </button>

        <h2 style={{ margin: '0 0 1.5rem 0', fontSize: '1.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <Target color="var(--strava-orange)" /> Nueva Competición
        </h2>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Nombre de la Prueba *</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} placeholder="Ej. Maratón de Valencia" style={{
              background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%'
            }} required />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Fecha y Hora *</label>
              <input type="datetime-local" name="date" value={formData.date} onChange={handleChange} style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%', colorScheme: 'dark'
              }} required />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Ubicación</label>
              <input type="text" name="location" value={formData.location} onChange={handleChange} placeholder="Ej. Valencia" style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%'
              }} />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Deporte</label>
              <select name="type" value={formData.type} onChange={handleChange} style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%', cursor: 'pointer'
              }}>
                <option value="running">Running</option>
                <option value="cycling">Ciclismo</option>
                <option value="triathlon">Triatlón</option>
                <option value="swimming">Natación</option>
              </select>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Prioridad</label>
              <select name="priority" value={formData.priority} onChange={handleChange} style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%', cursor: 'pointer'
              }}>
                <option value="A">Objetivo A (Principal)</option>
                <option value="B">Objetivo B (Secundario)</option>
                <option value="C">Objetivo C (Entrenamiento)</option>
              </select>
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '0.5rem' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Distancia *</label>
              <input type="text" name="distance" value={formData.distance} onChange={handleChange} placeholder="Ej. 42K" style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%'
              }} required />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Desnivel</label>
              <input type="text" name="elevation" value={formData.elevation} onChange={handleChange} placeholder="Ej. +200m" style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%'
              }} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
              <label style={{ fontSize: '0.85rem', color: 'var(--text-secondary)' }}>Tiempo Meta</label>
              <input type="text" name="targetTime" value={formData.targetTime} onChange={handleChange} placeholder="Ej. 2:55:00" style={{
                background: 'rgba(0,0,0,0.2)', border: '1px solid var(--glass-border)', padding: '0.8rem 1rem', borderRadius: '12px', color: 'white', width: '100%'
              }} />
            </div>
          </div>

          <button type="submit" style={{
            marginTop: '1rem', background: 'var(--strava-orange)', color: 'white', border: 'none', padding: '1rem',
            borderRadius: '12px', fontSize: '1rem', fontWeight: 600, cursor: 'pointer', transition: 'all 0.2s',
            boxShadow: '0 4px 15px rgba(252, 76, 2, 0.3)'
          }} onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'} onMouseOut={e => e.currentTarget.style.transform = 'translateY(0)'}>
            Guardar Competición
          </button>
        </form>

      </div>
    </div>
  );
};

export default EventModal;
